import {
  AtlassianIcon,
  BitbucketIcon,
  ConfluenceIcon,
  JiraCoreIcon,
  JiraIcon,
  JiraServiceDeskIcon,
  JiraServiceManagementIcon,
  JiraWorkManagementIcon,
  OpsGenieIcon,
  TrelloIcon,
} from '@atlaskit/logo';
import _memoize from 'lodash/memoize';
import * as React from 'react';
import AppCloudIcon from '../../assets/img/icon-app-cloud.svg';
import AppServerIcon from '../../assets/img/icon-app-server.svg';
import BambooCloudIcon from '../../assets/img/icon-bamboo-cloud.svg';
import BambooServerIcon from '../../assets/img/icon-bamboo-server.svg';
import BitbucketServerIcon from '../../assets/img/icon-bitbucket.svg';
import CloudIcon from '../../assets/img/icon-cloud.svg';
import CloverIcon from '../../assets/img/icon-clover.svg';
import ConfluenceServerIcon from '../../assets/img/icon-confluence.svg';
import CrowdIcon from '../../assets/img/icon-crowd.svg';
import CrucibleIcon from '../../assets/img/icon-crucible.svg';
import FisheyeIcon from '../../assets/img/icon-fisheye.svg';
import HipchatServerIcon from '../../assets/img/icon-hipchat.svg';
import JiraServerIcon from '../../assets/img/icon-jira.svg';
import ServiceIcon from '../../assets/img/icon-service.svg';
import SourcetreeIcon from '../../assets/img/icon-sourcetree.svg';
import StackIcon from '../../assets/img/icon-stack.svg';
import StrideIcon from '../../assets/img/icon-stride.svg';
import TrainingIcon from '../../assets/img/icon-training.svg';
import CompassIcon from '../../assets/img/icon-compass.svg';
import StatuspageIcon from '../../assets/img/icon-statuspage.svg';
import TeamCentralIcon from '../../assets/img/icon-team-central.svg';
import JiraIconNew from '../../assets/img/icon-jira-new.svg';
import unknownIconSrc from '../../assets/img/unknown.png';
import defaultAppIcon from '../../assets/img/icon-app-default.svg';
import BeaconIcon from '../../assets/img/icon-beacon.svg';
import AtlasIcon from '../../assets/img/icon-atlas.svg';
import WhiteBoardCanvasIcon from '../../assets/img/icon-whiteboard-canvas.svg';
import MercuryIcon from '../../assets/img/icon-mercury.svg';
import IntegratedAppsIcon from '../../assets/img/icon-integrated-apps.svg';
import JiraProductDiscoveryIcon from '../../assets/img/icon-jira-product-discovery.svg';
import LoomIcon from '../../assets/img/icon-loom.svg';
import RovoIcon from '../../assets/img/icon-rovo.svg';
import AtlassianGuardIcon from '../../assets/img/icon-atlassian-guard.svg';
import AddOnsIcon from '../../assets/img/icon-add-ons.svg';
import AppIcon from '../../assets/img/icon-app.svg';
import TeamworkCollectionIcon from '../../assets/img/icon-teamwork-collection.svg';

import {
  confluenceCloudIds,
  confluenceServerIds,
  jiraCloudIds,
  jiraCoreCloudId,
  jiraProductIds,
  jiraServerIds,
  jiraServiceDeskCloudIds,
  jiraServiceManagementIds,
  jiraSoftwareCloudId,
  jiraWorkManagementIds,
  statuspageIds,
} from '@atlassian/cssxp-utils-entitlement';
import { jiraProductDiscoveryIds } from '@atlassian/cssxp-utils-product';
import { STATUSPAGE_ADDON_PRODUCT_ID } from '@css-xp/ppc-constants';

export const UnknownIcon = (props: { [props: string]: any }) => <img src={unknownIconSrc} {...props} />;

const trelloIds = ['trello.free', 'trello.enterprise', 'trello.business_class', 'trello'];

const bitbucketCloudIds = ['bitbucket', 'com.atlassian.bitbucket', 'bitbucket.ondemand', 'bitbucket.cloud'];

const bitbucketServerIds = ['stash', 'stash-data-center', 'pricingplan.stash', 'pricingplan.stash-data-center'];

const sourcetreeIds = ['sourcetree', 'pricingplan.sourcetree'];

const crucibleIds = ['crucible', 'pricingplan.crucible'];

const fisheyeIds = ['fisheye', 'pricingplan.fisheye'];

const bambooCloudIds = ['bamboo.ondemand', 'pricingplan.bamboo.ondemand'];

const bambooServerIds = ['bamboo'];

const cloverIds = ['clover'];

const crowdIds = ['crowd', 'crowd.hosted', 'crowd.data-center', 'pricingplan.crowd'];

const atlassianAccessIds = ['com.atlassian.identity-manager', 'atlassian.organisation'];

const beaconIds = ['0a0a31b0-3f5f-4693-b231-9a753bee012e'];

const atlassianCloudIds = [
  'atlassian.cloud',
  'atlassian.hosted',
  'atlassian.ondemand',
  'pricingplan.atlassian.ondemand',
];

const atlassianCloudAppIds = [
  'bonfire.jira.ondemand',
  'pricingplan.bonfire.jira.ondemand',
  'com.radiantminds.roadmaps-jira.ondemand',
  'com.atlassian.confluence.extra.team-calendars.ondemand',
  'pricingplan.team.calendars.confluence.ondemand',
  'team.calendars.confluence.ondemand',
  'com.atlassian.confluence.plugins.confluence-questions.ondemand',
];

const atlassianServerAppIds = [
  'com.atlassian.bonfire.plugin',
  'com.radiantminds.roadmaps-jira',
  'pricingplan.com.radiantminds.roadmaps-jira',
  'com.atlassian.confluence.extra.team-calendars',
  'com.atlassian.confluence.plugins.confluence-questions',
  'pricingplan.com.atlassian.confluence.extra.team-calendars',
];

const strideIds = ['com.atlassian.hipchat', 'hipchat.cloud'];

const hipchatServerIds = ['com.atlassian.hipchat.server', 'com.atlassian.hipchat.data-center'];

const stackIds = ['stack.data-center'];

const serviceIds = [
  'technical-account-management',
  'ela',
  'premier-support',
  'pricingplan.premier-support',
  'pricingplan.technical-account-management',
];

const trainingIds = [
  'atlassian.university.greenhopper',
  'atlassian.university.confluence',
  'atlassian.university.jira',
  'training.credits',
  'training.additional-hosted-lab-instance',
  'bamboo.training',
  'jira.training',
  'training.classkit.confluence-admin-certification-prep',
  'training.classkit.jira-agile-dev-certification-prep',
  'training.classkit.jira-essentials',
  'training.classkit.getting-more-from-jira-agile',
  'training.classkit.getting-more-from-jira-workflows',
  'training.classkit.jira-confluence-integration',
  'training.classkit.getting-a-service-desk-up-and-running',
  'training.classkit.jira-reports-and-dashboards',
  'training.classkit.getting-started-with-confluence',
  'training.classkit.getting-more-from-confluence',
  'training.classkit.getting-started-with-jira-agile',
  'training.classkit.agile-development-with-atlassian-dev-tools',
  'training.classkit.jira-admin-part-1',
  'training.classkit.jira-admin-part-2',
  'jira-servicedesk.training.recorded',
  'jira-servicedesk.training',
  'confluence.training',
  'jira.training.recorded',
  'confluence.training.recorded',
  'greenhopper.training.recorded',
  'training.classkit.jira-admin-certification-prep',
  'acpfullvoucher.training',
  'devtools.training',
  'greenhopper.training',
  'onsite.training',
  'stash.training',
];

const opsgenieIds = ['opsgenie', 'fdb4649d-ca4d-49f8-a8bf-ffa558a65551'];

const compassIds = ['compass', '6bce2ccb-4f57-46f5-812a-9dbf02dc28f2'];

const teamCentralIds = ['townsquare'];

const atlasIds = ['7c917705-866d-4b6b-b266-0fc7633e8342'];

const whiteBoardCanvasIds = ['b6c5632b-6018-4656-b2ac-3e32e7cef0d3'];

const mercuryIds = ['d16a2ba8-445f-4e83-9c7b-9bcf349ff905'];

const integratedAppsIds = ['integrated-apps'];

const atlassianGuardProductIds = ['ad8473d4-3a4d-4e36-827c-0a893439e9fa', '17e4ba8d-5eba-43d4-bb6b-07dd3824b06f'];

const loomProductIds = ['7683a73e-423d-41a1-b43f-d497656f8b5d'];

const rovoProductIds = ['91ae3e3f-138e-43be-98cc-48df03d13c32'];

const addOnsProductIds = [
  'd507d4e4-49b0-4b87-9905-d20993607a56',
  'd869ebdc-8a57-4526-92a6-1177070b651b',
  STATUSPAGE_ADDON_PRODUCT_ID,
];

const teamWorkCollectionIds = ['3503c251-c247-4b55-a6ed-d4c8c3257b8b'];

const strategyCollectionIds = ['3e6f105a-4f6d-44d1-8716-7e9468544d93'];

const bitbucketProductIds = ['ad1076cd-0b3f-4e57-8f46-3dcd70ee259f'];

export const getIconByProductId = _memoize(
  (productId: string): React.ComponentType<{ [prop: string]: unknown }> => {
    if (trelloIds.includes(productId)) {
      return TrelloIcon;
    } else if (atlassianCloudIds.includes(productId)) {
      return CloudIcon;
    } else if (atlassianAccessIds.includes(productId)) {
      return AtlassianIcon;
    } else if (atlassianCloudAppIds.includes(productId)) {
      return AppCloudIcon;
    } else if (atlassianServerAppIds.includes(productId)) {
      return AppServerIcon;
    } else if (bitbucketCloudIds.includes(productId)) {
      return BitbucketIcon;
    } else if (bitbucketServerIds.includes(productId)) {
      return BitbucketServerIcon;
    } else if (bambooServerIds.includes(productId)) {
      return BambooServerIcon;
    } else if (bambooCloudIds.includes(productId)) {
      return BambooCloudIcon;
    } else if (cloverIds.includes(productId)) {
      return CloverIcon;
    } else if (confluenceCloudIds.includes(productId)) {
      return ConfluenceIcon;
    } else if (confluenceServerIds.includes(productId)) {
      return ConfluenceServerIcon;
    } else if (crowdIds.includes(productId)) {
      return CrowdIcon;
    } else if (crucibleIds.includes(productId)) {
      return CrucibleIcon;
    } else if (fisheyeIds.includes(productId)) {
      return FisheyeIcon;
    } else if (jiraServerIds.includes(productId)) {
      return JiraServerIcon;
    } else if (jiraCloudIds.includes(productId)) {
      return JiraIcon;
    } else if (jiraServiceDeskCloudIds.includes(productId)) {
      return JiraServiceDeskIcon;
    } else if (jiraSoftwareCloudId.includes(productId)) {
      return JiraIconNew;
    } else if (jiraCoreCloudId.includes(productId)) {
      return JiraCoreIcon;
    } else if (jiraWorkManagementIds.includes(productId)) {
      return JiraWorkManagementIcon;
    } else if (jiraServiceManagementIds.includes(productId)) {
      return JiraServiceManagementIcon;
    } else if (hipchatServerIds.includes(productId)) {
      return HipchatServerIcon;
    } else if (strideIds.includes(productId)) {
      return StrideIcon;
    } else if (serviceIds.includes(productId)) {
      return ServiceIcon;
    } else if (sourcetreeIds.includes(productId)) {
      return SourcetreeIcon;
    } else if (stackIds.includes(productId)) {
      return StackIcon;
    } else if (trainingIds.includes(productId)) {
      return TrainingIcon;
    } else if (opsgenieIds.includes(productId)) {
      return OpsGenieIcon;
    } else if (statuspageIds.includes(productId)) {
      return StatuspageIcon;
    } else if (compassIds.includes(productId)) {
      return CompassIcon;
    } else if (teamCentralIds.includes(productId)) {
      return TeamCentralIcon;
    } else if (jiraProductIds.includes(productId)) {
      return JiraIconNew;
    } else if (productId === 'default-app-icon-id') {
      return defaultAppIcon;
    } else if (beaconIds.includes(productId)) {
      return BeaconIcon;
    } else if (atlasIds.includes(productId)) {
      return AtlasIcon;
    } else if (whiteBoardCanvasIds.includes(productId)) {
      return WhiteBoardCanvasIcon;
    } else if (mercuryIds.includes(productId)) {
      return MercuryIcon;
    } else if (integratedAppsIds.includes(productId)) {
      return IntegratedAppsIcon;
    } else if (jiraProductDiscoveryIds.includes(productId)) {
      return JiraProductDiscoveryIcon;
    } else if (atlassianGuardProductIds.includes(productId)) {
      return AtlassianGuardIcon;
    } else if (loomProductIds.includes(productId)) {
      return LoomIcon;
    } else if (rovoProductIds.includes(productId)) {
      return RovoIcon;
    } else if (addOnsProductIds.includes(productId)) {
      return AddOnsIcon;
    } else if (teamWorkCollectionIds.includes(productId)) {
      return TeamworkCollectionIcon;
    } else if (strategyCollectionIds.includes(productId)) {
      return TeamworkCollectionIcon;
    } else if (bitbucketProductIds.includes(productId)) {
      return BitbucketIcon;
    } else {
      return AppIcon;
    }
  }
);
